"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_deburr_1 = __importDefault(require("lodash.deburr"));
class StringSanitizer {
    validateType(value) {
        return typeof value === 'string';
    }
    sanitize(value) {
        return (0, lodash_deburr_1.default)(value).replace(/\s+/g, ' ').toLocaleLowerCase();
    }
}
exports.default = new StringSanitizer();
